// source: core/contract/common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('@tronweb3/google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.protocol.ResourceCode', null, global);
/**
 * @enum {number}
 */
proto.protocol.ResourceCode = {
  BANDWIDTH: 0,
  ENERGY: 1,
  TRON_POWER: 2
};

goog.object.extend(exports, proto.protocol);
